import { TRootState } from "@/store/app/store";

export const loadDataSelector = (state: TRootState) => state.loadInfo.data;
export const includeDeadHeadSelector = (state: TRootState) =>
  state.loadInfo.includeDeadHead;

export const sourceSelector = (state: TRootState) => state.loadInfo.source;
